export default {
  JSON: {
    merge: false,
  },
};
